import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../Services/apiService";

export const GetBeneficiaryInformation = createAsyncThunk(
  "PersonalInformation/GetBeneficiaryInformation",
  async (aI_ApplicationInformationId, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/BeneficiaryInformation/GetBeneficiaryInformation",
        {
          aI_ApplicationInformationId: aI_ApplicationInformationId,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const BeneficiaryInformation = createSlice({
  name: "BeneficiaryInformation",
  initialState: {
    BeneficiaryInformation: {},
    loadingBeneficiaryInformation: false,
    errorBeneficiaryInformation: null,
  },
  reducers: {
    SetBeneficiaryInformation: (state, action) => {
      state.BeneficiaryInformation = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(GetBeneficiaryInformation.pending, (state, action) => {
        state.loadingBeneficiaryInformation = true;
        state.BeneficiaryInformation = action.payload;
        state.errorBeneficiaryInformation = null;
      })
      .addCase(GetBeneficiaryInformation.fulfilled, (state, action) => {
        state.loadingBeneficiaryInformation = false;
        state.BeneficiaryInformation = action.payload;
      })
      .addCase(GetBeneficiaryInformation.rejected, (state, action) => {
        state.loadingBeneficiaryInformation = false;
        state.errorBeneficiaryInformation = action.payload;
      });
  },
});
export const { SetBeneficiaryInformation } = BeneficiaryInformation.actions;

export default BeneficiaryInformation.reducer;
